import React, {useEffect, useState} from "react";
import BrandAndModelSearch from "../ProductSearchField/BrandAndModelSearch";
import URLSearchParamsConverter from "../../utils/URLSearchParamsConverter";
import {useHistory, useLocation} from "react-router";

function ModelsSubmenu(props) {

    const [selectedBrands, setSelectedBrands] = useState([]);
    const [selectedModels, setSelectedModels] = useState([]);

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(location.search);
        setSelectedBrands(URLSearchParamsConverter.searchBrands(urlSearchParams.get("brands"), props.brandsAndModels));
        setSelectedModels(URLSearchParamsConverter.searchModels(urlSearchParams.get("models"), props.brandsAndModels));
    }, [location.search, props.brandsAndModels]);

    const changeBrandHandler = (brands) => {
        setSelectedBrands(brands);
    };

    const changeModelHandler = (models) => {
        setSelectedModels(models);
    };

    const searchButtonClicked = () => {
        let searchParameters = {
            brands: selectedBrands,
            models: selectedModels
        }

        history.push({
            pathname: "/lista-ofert",
            search: URLSearchParamsConverter.createURLSearchString(searchParameters)
        });

        props.onClose();
    }

    return (

        <form action="">
            <BrandAndModelSearch
                selectedBrands={selectedBrands}
                selectedModels={selectedModels}
                resetBrands={selectedBrands.length === 0}
                brandsAndModels={props.brandsAndModels}
                onBrandChange={changeBrandHandler}
                onModelChange={changeModelHandler} />

            <button type="button" onClick={searchButtonClicked}>Szukaj</button>
        </form>
    );
}

export default ModelsSubmenu;